import { DataTable } from '@/shared/components/DataTable/DataTable'
import { formatDateDMY } from '@/shared/utils/formatDate'
import { StatusBadge } from '@/shared/components/StatusBadge/StatusBadge'
import type { RoleListItem } from '../../services/roles/roles.types'

type AllRolesProps = {
  mode?: 'active' | 'deleted'
  roles: RoleListItem[]
  onEdit?: (role: RoleListItem) => void
  onDelete?: (role: RoleListItem) => void
  onDuplicate?: (role: RoleListItem) => void
  onRestore?: (role: RoleListItem) => void
}

export default function AllRoles({
  mode = 'active',
  roles,
  onEdit,
  onDelete,
  onDuplicate,
  onRestore,
}: AllRolesProps) {
  const columns =
    mode === 'deleted'
      ? [
          {
            key: 'title',
            header: 'Role',
            render: (row: RoleListItem) => row.title,
          },
          {
            key: 'created_datetime_timestamp',
            header: 'Created Date',
            render: (row: RoleListItem) =>
              formatDateDMY(row.created_datetime_timestamp ?? '-'),
          },
          {
            key: 'last_modified_datetime_timestamp',
            header: 'Deleted Date',
            render: (row: RoleListItem) =>
              formatDateDMY(row.last_modified_datetime_timestamp ?? '-'),
          },
        ]
      : [
          {
            key: 'title',
            header: 'Role',
            render: (row: RoleListItem) => row.title,
          },
          {
            key: 'role_type',
            header: 'Role Type',
            render: (row: RoleListItem) => (
              <StatusBadge
                type={row.role_type === 'default' ? 'verified' : 'unverified'}
                labelOverride={
                  row.role_type === 'default' ? 'Default' : 'Custom'
                }
              />
            ),
          },
          {
            key: 'created_datetime_timestamp',
            header: 'Created Date',
            render: (row: RoleListItem) =>
              formatDateDMY(row.created_datetime_timestamp ?? '-'),
          },
          {
            key: 'associated_users',
            header: 'Associated Users',
            render: (row: RoleListItem) => row.associated_users,
          },
        ]

  const actions =
    mode === 'deleted'
      ? [
          {
            icon: 'rotate_left',
            label: 'Restore Role',
            onClick: (row: RoleListItem) => onRestore?.(row),
          },
        ]
      : [
          {
            icon: 'edit',
            label: 'Edit Role',
            onClick: (row: RoleListItem) => onEdit?.(row),
          },
          {
            icon: 'content_copy',
            label: 'Duplicate Role',
            onClick: (row: RoleListItem) => onDuplicate?.(row),
          },
          {
            icon: 'delete',
            label: 'Delete Role',
            onClick: (row: RoleListItem) => onDelete?.(row),
          },
        ]

  return <DataTable columns={columns} data={roles} actions={actions} />
}
